<template>
  <div>
    <div v-if="email" class="email-header">
      <div class="hidden-md-and-up">
        <v-btn
          class="pa-0"
          color="blue"
          style="min-width: 0; padding: 0; margin-left: -5px;"
          text
          @click="
            () => {
              this.$emit('close');
            }
          "
        >
          <v-icon dense>mdi-chevron-left</v-icon> Back
        </v-btn>
      </div>
      <ReceivedEmailHeader v-if="email.email" :email="email" />
      <SentEmailHeader v-if="!email.email" :email="email" />
    </div>
    <div class="email-body">
      <div v-if="email" class="email">
        <div class="messages-layout">
          <div id="messages-scroll" class="messages-container">
            <div class="messages pa-4">
              <div v-if="body">
                <div class="mb-5">
                  <img
                    class="email-logo mb-5"
                    src="../../assets/images/teambot-logo-mid-centered-alpha.png"
                  />
                  <v-divider />
                </div>
                <p v-html="body"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import ReceivedEmailHeader from "@/components/Email/ReceivedEmailHeader";
import SentEmailHeader from "@/components/Email/SentEmailHeader";

export default Vue.extend({
  name: "EmailMessage",
  components: { SentEmailHeader, ReceivedEmailHeader },
  props: ["email"],
  data() {
    return {
      showAllRecipients: false
    };
  },
  computed: {
    body() {
      return this.theEmail ? this.theEmail.message : null;
    },
    subject() {
      return this.theEmail ? this.theEmail.subject : null;
    },
    theEmail() {
      if (!this.email) {
        return null;
      } else if (this.email.email) {
        return this.email.email;
      } else {
        return this.email;
      }
    },
    visibleRecipients() {
      const recipients = this.email.recipients || [];
      if (this.showAllRecipients) {
        return recipients;
      } else {
        return recipients.length > 10 ? recipients.slice(0, 10) : recipients;
      }
    },
    hiddenRecipients() {
      const recipients = this.email.recipients || [];
      if (this.showAllRecipients) {
        return [];
      } else {
        return recipients.length > 10 ? recipients.slice(10) : [];
      }
    }
  }
});
</script>
<style scoped>
.email-body {
  height: calc(
    100vh - (88px + 115px)
  ); /* viewport-height - (top bar + email-header) */
  overflow: scroll;
}

.email-header {
  overflow: hidden;
  min-height: 90px;
  margin-bottom: 5px;
  border-bottom: 1px solid #ddd;
  padding: 5px 15px 15px 15px;
}

.email-message {
  display: flex;
  flex-direction: column;
  color: black;
  height: 100%;
  align-items: stretch;
}

.email-message-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: black;
  padding: 20px;
  cursor: pointer;
  height: 100%;
  align-items: stretch;
}

.email-logo {
  max-width: 300px;
  display: flex;
  margin: auto;
}

.messages-layout {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  max-height: 100%;
}

.messages-container {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  flex-grow: 1;
  padding-left: 15px;
  padding-right: 15px;
}

.send-message {
  padding-right: 20px;
  /*position: absolute;*/
  /*  bottom: 20px;*/
  /*  left: 15px;*/
  /*right: 15px;*/
}

.send-message-file-input {
  height: 0;
  z-index: 1000;
  margin-left: 34px;
  background-color: #f9f9f9;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.image-delete {
  position: absolute;
  top: 4px;
  right: 4px;
}

.file-attachment {
  margin-top: -45px;
  margin-left: -2px;
  max-width: 33%;
  min-width: 200px;
  height: 40px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 10px 5px 5px 10px;
  font-size: 11px;
  color: black;
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 1000;
}
.file-attachment:hover {
  color: #666;
  cursor: pointer;
}
.file-attachment:hover span {
  color: darkred;
  text-decoration: line-through;
}
.file-attachment:hover .v-icon {
  color: darkred;
}

.file-attachment .v-icon {
  margin-top: -2px;
  margin-right: 10px;
  color: black;
}

.black-icon-background {
  position: absolute;
  top: 7px;
  right: 7px;
  background-color: black;
  width: 18px;
  border-radius: 50%;
  height: 18px;
  box-shadow: 1px 1px 5px black;
}

.message-input .v-icon {
  color: dodgerblue !important;
}

/deep/ .mdi-camera {
}

.unread-indicator .v-icon {
  color: transparent;
  float: right;
}

.has-unread .unread-indicator .v-icon {
  color: red;
}

.v-dialog__content {
  --background-color: black;
}

.members-typing {
  color: red;
  text-align: center;
}

/*.members .member:after,*/
/*.members-typing .member:after {*/
/*  content: ", ";*/
/*}*/

.members .member:last-child:after,
.members-typing .member:last-child:after,
.members .member:nth-last-child(2):after,
.members-typing .member:nth-last-child(2):after {
  content: "" !important;
}

/*.members .member:last-child:before,*/
/*.members-typing .member:nth-child(n + 2):last-child:before {*/
/*  content: " and ";*/
/*}*/

.members .member:first-child:before,
.members-typing .member:first-child:before {
  content: "" !important;
}

.tb-red-bg {
  background-color: var(--tb-red) !important;
  color: white;
}

.member-layout {
  background: white;
}

@media (min-width: 960px) {
  .back-button {
    display: none;
  }

  .email-header {
    padding: 20px;
  }
}
</style>
<style>
.send-message textarea {
  max-height: 300px !important;
  overflow: scroll !important;
}
</style>
